import React from 'react'
import { kebabCase } from 'lodash'
import pluralize from 'pluralize'

export const CategorySidebarRow = ({ name, itemCount }) => {
  return (
    <div className="playbook-category-row">
      <div className="playbook-category-row__name">
        <a href={`#${kebabCase(name)}`}>{name}</a>
      </div>
      <div className="playbook-category-row__count">
        {`${itemCount} ${pluralize('item', itemCount)}`}
      </div>
    </div>
  )
}
